/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-15 13:46:42
 * @LastEditors: K
 * @LastEditTime: 2022-09-27 17:58:44
 */
export function isValidMobileNumber(num: string): boolean {
  return num.length === 11 && (num[0] === "1" || num[0] === "5")
}

export function getAge(age: number, month: number, postfix = ""): string {
  if (age > 0) {
    return `${age}${postfix}`
  }
  if (month <= 0) {
    return `0${postfix}`
  }
  return `${month}个月`
} 
export function getAgeName(age: number, month: number): string {
  if (age > 0) {
    return `${age}y`
  }
  if (month <= 0) {
    return `0d`
  }
  return `${month}m`
}


export const stringTrim = (e:any) => {
  if (!e) {
    return ''
  }
  if (e.target && e.target.value !== undefined) {
    return e.target.value.replace(/(^\s*)|(\s*$)/g, '')
  }
  return String(e).replace(/(^\s*)|(\s*$)/g, '')
}